<mat-card class="attachment-card">
  <mat-card-header class="attachment-card-title">
    <mat-card-title class="attachment-card-title">{{ attachmentThumbnail.title }}</mat-card-title>
  </mat-card-header>
  @if (isImageFile) {
    <img mat-card-image [src]="attachmentThumbnail.url" [alt]="attachmentThumbnail.title" />
  } @else if (attachmentThumbnail.mimeType.startsWith('application/pdf')) {
    <div class="thumbnail">
      <mat-icon>picture_as_pdf</mat-icon>
    </div>
  } @else {
    <div class="thumbnail">
      <mat-icon>insert_drive_file</mat-icon>
    </div>
  }
  <mat-card-actions class="actions">
    <button
      *ngIf="this.attachmentThumbnail?.id"
      mat-mini-fab
      aria-label="Download"
      (click)="onDownloadClicked()"
      [disabled]="
        (!attachmentThumbnail.url && !attachmentThumbnail.mimeType.startsWith('application/')) ||
        isDownloadOperationInProgress ||
        isPreviewInProgress
      "
      type="button"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>
    <button
      mat-mini-fab
      aria-label="Remove"
      (click)="onDeleteClicked()"
      type="button"
      [disabled]="isDownloadOperationInProgress || isPreviewInProgress"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button
      *ngIf="this.attachmentThumbnail?.id"
      mat-mini-fab
      aria-label="Preview"
      (click)="onPreviewClicked()"
      [disabled]="
        !reviewableFileTypes.includes(attachmentThumbnail.mimeType) ||
        isDownloadOperationInProgress ||
        isPreviewInProgress
      "
      type="button"
    >
      <mat-icon>visibility</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
